import { render, staticRenderFns } from "./TreasuryMain.vue?vue&type=template&id=148f5080"
import script from "./TreasuryMain.vue?vue&type=script&lang=js"
export * from "./TreasuryMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports